import { ReactNode } from 'react';
import Dialog, { DialogProps } from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import CloseIcon from '@mui/icons-material/Close';
import { IconButton, Typography } from '@mui/material';

interface GenericModalProps extends Omit<DialogProps, 'title'> {
    onClose: () => void;
    title: string | ReactNode;
    actions?: ReactNode;
    headerBackgroundColor?: string;
    headerTextColor?: string;
}

const BaseModal = ({
    open,
    onClose,
    title,
    children,
    actions,
    maxWidth = 'sm',
    headerBackgroundColor = 'primary.main',
    headerTextColor = 'primary.contrastText',
    scroll = 'paper',
    fullWidth = true,
    ...other
}: GenericModalProps) => {
    return (
        <Dialog fullWidth={fullWidth} maxWidth={maxWidth} open={open} onClose={onClose} scroll={scroll} {...other}>
            <DialogTitle
                sx={{
                    m: 0,
                    p: 2,
                    backgroundColor: headerBackgroundColor,
                    color: headerTextColor,
                    display: 'flex',
                    alignItems: 'center',
                }}>
                <Typography variant='h5' component='div' sx={{ flexGrow: 1, ml:2 }}>
                    {title}
                </Typography>
                <IconButton
                    aria-label='close'
                    onClick={onClose}
                    sx={{
                        color: headerTextColor,
                    }}>
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent dividers={scroll === 'paper'}>{children}</DialogContent>
            {actions && <DialogActions sx={{ padding: 2, justifyContent: 'flex-end' }}>{actions}</DialogActions>}
        </Dialog>
    );
};

export default BaseModal;
